export default __webpack_public_path__ + "static/media/027-silver medal.b6cd003e.svg";